import { getUserApiData } from "../../utils/UserUtils";
import { invokeApig } from "../../libs/awsLib";
import Paths from "../paths";
import { myID } from "../../libs/generateID";
import store from "../../store/store";
import { notify } from "reapop";
import i18n from "../../i18n";
import { createErrorNotification, createSuccessNotification } from "../../utils/ResponseUtils";

/**
 * @typedef FallPigletsData
 * @type {object}
 * @property AnmID {string}         ID zwierzecia
 * @property Piglets {number}       Liczba prosiąt
 * @property EvTime {number}        czas wykonania zdarzeniia (możliwe, że przejdzie do tablicy animals)
 * @property Comment {string}       komentarz
 * @property GrID {string}          id grupy
 * @property Weight {number}        waga upadłych prosiąt
 * @property Reason {string}        powód upadku
 * @property PlcmntID {string}      miejsce, w ktorym znajdowalo sie zwierze
 */

/**
 * Metoda wysyła zapytanie o stworzenie nowego upadku prosiat
 * @param data {[FallPigletsData]}          Dane zdarzenia
 * @param FarmID {string|null}              ID fermy
 * @param ClientID {string|null}            ID klienta
 * @param LocalUserID {string|null}         ID użytkownika
 * @return {Promise<*|undefined>}
 */
export function createFallPiglets(data, { FarmID, ClientID, LocalUserID } = {}) {
    const { _FarmID, _LocalUserID, _ClientID } = getUserApiData({ FarmID, ClientID, LocalUserID });
    return invokeApig({
        ...Paths.createFallPiglets({ farmID: _FarmID, clientID: _ClientID, localUserID: _LocalUserID }),
        body: data
    })
}

export function createFallPigletsNotificationSuccess(response, { uniqueId = myID() } = {}) {
    if (createSuccessNotification(response, "apiNotifications.createFallPigletsTitle")) return;
    store.dispatch(notify({
        id: uniqueId,
        title: i18n.t("apiNotifications.createFallPigletsTitle"),
        message: i18n.t("apiNotifications.createFallPigletsSuccess"),
        status: 'success',
        dismissible: true,
        dismissAfter: 5000
    }))
}

export function createFallPigletsNotificationFailure(response, { uniqueId = myID() } = {}) {
    if (createErrorNotification(response, "apiNotifications.createFallPigletsTitle", { uniqueId })) return;
    store.dispatch(notify({
        id: uniqueId,
        title: i18n.t("apiNotifications.createFallPigletsTitle"),
        message: i18n.t("apiNotifications.createFallPigletsFailure"),
        status: 'error',
        dismissible: true,
        // buttons: checkLogsButton(),
        dismissAfter: 15000
    }))
}
